import React, { useState } from "react";
import Button from "../components/Button";
import Input from "../components/Input";
import firebase from "firebase";
import styled from "styled-components";
import { NavLink, useHistory } from "react-router-dom";
import logo from "../assets/logo.jpg";
import { notification } from "antd";

const LoginWrapper = styled.div`
  display: flex;
  margin: auto;
  height: 100vh;
  justify-content: center;
  flex-direction: column;
  width: 360px;
  text-align: center;
  input {
    margin-bottom: 8px;
  }
  button {
    margin-top: 16px;
  }
`;

const ResetPassword = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");

  const [error, setError] = useState("");

  const onResetPassword = async () => {
    setError("");
    setIsLoading(true);

    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        setIsLoading(false);
        history.push("/");
      })
      .catch((e) => {
        setIsLoading(false);
        notification.success({
          message: "Password reset email sent",
        });
        switch (e.code) {
          case "auth/user-not-found":
            setError("This user does not exist");
            break;
          case "auth/wrong-password":
            setError("Incorrect password");
            break;
          default:
            setError(e.code);
            break;
        }
      });
  };

  return (
    <LoginWrapper>
      <img
        src={logo}
        alt="Young Coderz Logo"
        style={{ width: 96, margin: "8px auto" }}
      />
      <h2>Forgotten your password?</h2>
      <Input
        value={email}
        onChange={(e) => setEmail(e.currentTarget.value)}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            onResetPassword();
          }
        }}
        placeholder="Email"
        type="email"
      />
      <Button onClick={onResetPassword} disabled={isLoading}>
        {isLoading ? "Resetting..." : "Send a password reset email"}
      </Button>
      {error && error}
      <NavLink to="/login" style={{ marginTop: 16 }}>
        Back to login
      </NavLink>
    </LoginWrapper>
  );
};

export default ResetPassword;
